module.exports = __webpack_public_path__ + "static/media/apartment1.f73bdf6e.png";